import { TableSettings } from '@adnova/jf-ng-components';

import { TABLE_COLUMNS } from './table-columns.const';
import { STORAGE_KEY_ADMIN_ANNOUNCEMENT_TABLE } from '../../../constants/storage-keys.const';

/**
 * Standard-Tabellen-Einstellungen für jf-table.
 *
 * Abgeleitet aus {@link TABLE_COLUMNS}.
 */
export const DEFAULT_TABLE_SETTINGS: TableSettings = {
  _key: STORAGE_KEY_ADMIN_ANNOUNCEMENT_TABLE,
  _columns: TABLE_COLUMNS.map(col => ({
    id: col.id,
    name: col.name,
    isActive: col.isActive !== false,
    sortable: col.sortable,
    width: col.width,
    ...(col.sortId && { sortIds: { asc: col.sortId, desc: col.sortId } }),
  })),
  _sortDirs: ['desc'],
  _sortParams: ['createdAt'],
};
